import _map from 'lodash/map';
import _intersection from 'lodash/intersection';
import BasePerimeter from '@/kindergarten/perimeters/BasePerimiter';

export default new BasePerimeter({
  purpose: 'entity',

  can: {
    view(allowedRoles) {
      if (!this.child) return false;
      const roles = _map(this.child.roles, el => el.name);
      return !!_intersection(roles, allowedRoles).length;
    },

    update(entity) {
      return this.isAdmin() || this.isCreator(entity) || this.isAssignee(entity) || this.isSupervisor(entity);
    },

    destroy(entity) {
      return this.isAdmin() || this.isCreator(entity);
    },
  },

  expose: [
    'isManager',
    'isFollower',
    'isInternal',
    'isCreator',
    'isAdmin',
    'isSls',
    'isOps',
    'isLog',
  ],
});



// WEBPACK FOOTER //
// ./src/kindergarten/perimeters/EntityPerimeter.js